
(function() {
  window.YobekGiftBagUpsell = {
    initialized: false,
    
    init() {
      if (this.initialized) return;
      
      document.addEventListener('click', this.handleClick.bind(this), true);
      document.addEventListener('change', this.handleChange.bind(this), true);
      
      document.addEventListener('cart:refresh', () => {
        setTimeout(() => this.checkAndInitialize(), 100);
      });
      
      document.addEventListener('shopify:section:load', () => {
        this.checkAndInitialize();
      });
      
      this.initialized = true;
      this.checkAndInitialize();
    },
    
    checkAndInitialize() {
      const upsellElements = document.querySelectorAll('[data-giftbag-upsell]:not([data-initialized])');
      upsellElements.forEach(element => {
        element.setAttribute('data-initialized', 'true');
        this.initializeElement(element);
      });
    },
    
    initializeElement(element) {
      const defaultOption = element.querySelector('[data-giftbag-option] input:checked');
      if (defaultOption) {
        const label = defaultOption.closest('[data-giftbag-option]');
        if (label) {
          label.classList.add('is-selected');
          // 初期選択時の説明文更新（価格は既にLiquidで設定済み）
          this.updateDescription(element, defaultOption.value);
        }
      }
    },
    
    handleClick(event) {
      const option = event.target.closest('[data-giftbag-option]');
      if (option) {
        event.preventDefault();
        this.selectOption(option);
        return;
      }
      
      const addButton = event.target.closest('[data-giftbag-add-trigger]');
      if (addButton) {
        event.preventDefault();
        this.addToCart(addButton);
        return;
      }
    },
    
    handleChange(event) {
      const option = event.target.closest('[data-giftbag-option]');
      if (option) {
        this.selectOption(option);
      }
    },
    
    selectOption(option) {
      const container = option.closest('.cart-upsell__sizes');
      if (!container) return;
      
      const upsellRoot = option.closest('[data-giftbag-upsell]');
      const input = option.querySelector('input[type="radio"]');
      
      container.querySelectorAll('[data-giftbag-option]').forEach(node => {
        const isSelected = node === option;
        node.classList.toggle('is-selected', isSelected);
        const radioInput = node.querySelector('input[type="radio"]');
        if (radioInput) radioInput.checked = isSelected;
      });
      
      // 選択に応じて説明文と価格を更新
      if (input && upsellRoot) {
        this.updateDescription(upsellRoot, input.value);
        this.updatePrice(upsellRoot, option.dataset.price);
      }
    },
    
    updateDescription(upsellRoot, variantId) {
      const descElement = upsellRoot.querySelector('[data-giftbag-description]');
      if (!descElement) return;
      
      // バリアントIDによってサイズを判定
      const size = variantId === '54706693308489' ? 'm' : 'l';
      descElement.setAttribute('data-size', size);
    },
    
    updatePrice(upsellRoot, price) {
      const priceElement = upsellRoot.querySelector('[data-giftbag-price]');
      if (!priceElement) return;
      
      // 価格を直接テキストとして更新
      priceElement.textContent = '¥' + price;
    },
    
    addToCart(button) {
      const upsellRoot = button.closest('[data-giftbag-upsell]');
      if (!upsellRoot) return;
      
      const selectedInput = upsellRoot.querySelector('input[name="giftbag-variant"]:checked');
      const feedback = upsellRoot.querySelector('[data-giftbag-feedback]');
      
      if (!selectedInput) {
        this.showMessage(feedback, 'サイズを選択してください。', 'error');
        return;
      }
      
      this.clearMessage(feedback);
      button.disabled = true;
      button.classList.add('is-loading');
      
      const formData = new FormData();
      formData.append('id', selectedInput.value);
      formData.append('quantity', '1');
      
      const sectionsToUpdate = button.dataset.sections || 'cart-drawer,cart-bubble';
      formData.append('sections', sectionsToUpdate);
      formData.append('sections_url', window.location.pathname);
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        if (data.status) {
          throw new Error(data.description || 'カートに追加できませんでした。');
        }
        
        document.dispatchEvent(new CustomEvent('cart:item-added', { 
          detail: { product: data.items ? data.items[0] : data }
        }));
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => {
        this.showMessage(feedback, error.message || '通信エラーが発生しました。', 'error');
      })
      .finally(() => {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
    },
    
    showMessage(element, text, type = 'info') {
      if (!element) return;
      element.textContent = text;
      element.className = 'cart-upsell__feedback';
      if (type) element.classList.add(`is-${type}`);
      element.hidden = false;
    },
    
    clearMessage(element) {
      if (!element) return;
      element.hidden = true;
      element.textContent = '';
      element.className = 'cart-upsell__feedback';
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.YobekGiftBagUpsell.init();
    });
  } else {
    window.YobekGiftBagUpsell.init();
  }
})();
